import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.dataClassification || initialState;

export const selectDataClassification = createSelector(
  [selectDomain],
  dataClassificationState => dataClassificationState,
);
